<template>
  <div class="zutai-editor" id="fullscreenElement" v-if="showIframe">
    <iframe ref="iframe" :src="graphViewerUrl" width="100%" height="100%" frameborder="0" />
    <!-- <choose-date-dialog ref="datePicker" :visible.sync="dialogVisible" @confirm="onChooseDate" /> -->
  </div>
</template>
<script>

import { graphViewerUrl, websocketUrl } from '@/config/env';
// import { detail as getViewDetail } from '@/api/ml-link/view'
// import { getHistoryDataCurve, getHistoryDataSum, getHistoryDataItemsSum } from '@/api/ml-link/historyData'
// import { list as getAlarmList, getDevAlarmCount as getAlarmCount } from '@/api/ml-link/equipmentalarm'
// import { getAllStationDevice as getBigScreenInfo } from '@/api/ml-link/bigscreen/first'
// import { detail as getStationDetail } from '@/api/ml-link/station'
// import { setYk, setYt } from '@/api/ml-link/control'
// import { startVideo } from '@/api/ml-link/camera'
// import ChooseDateDialog from '../zutai-editor/ChooseDateDialog.vue'
import { eleJfpgReport, getEleJfpgData as getBigScreenInfo, jfpgBarGraph } from '@/api/energyManage/reportData'
import { getDataPageDetail, updatePage } from '@/api/assemble/index';
// import {
//   getTreeList as getDSTreeList,
//   getFourRemoteTypes as getDSList,
//   getPointList,
//   getRtDataByItemIds,
//   getHistoryData as getHistoryDataCurve,
//   // getViewGroupTree,
//   getImageList, addImage, removeImage } from '@/api/assemble/editor'
  import {
  getTreeList as getDSTreeList,
  getFourRemoteTypes as getDSList,
  getTimeTypes,
  getCompareTypes,
  getRtDataByItemIds,
  getPointList,
  getHistoryData as getHistoryDataCurve,
  // getViewGroupTree,
  getImageList, addImage, removeImage } from '@/api/assemble/editor'

export default {
  name: 'ZutaiViewer',
  components: {
    // ChooseDateDialog
  },
  data() {
    return {
      graphViewerUrl,
      timeOptions: [],
      view: undefined,
      showIframe: false,
      iWindow: undefined,
      dialogVisible: false,
      dialogCallback: undefined
    }
  },
  mounted() {
    const zutaiId = this.$route.query.id
    if (zutaiId) {
      getTimeTypes().then(res => {
        const timeOptions = res.data.data;
          timeOptions.forEach(item => {
            item.label = item.i18nValue;
            item.value = item.dictKey;
          })
          this.timeOptions = timeOptions;
      })
      getDataPageDetail({ id: zutaiId }).then(res => {
        const viewData = res.data.data.viewData;
        if (viewData) {
          this.showIframe = true;
          this.$nextTick(() => {
            this.iWindow = this.$refs['iframe'].contentWindow
            this.iWindow.onPageLoadEnd = (show, window) => {
              this.bindWindowFuncs(window)
              show(viewData)
            }
            this.toggleFullscreen();
          })
        } else {
          // this.$router.push('/energyManage/energyAnalysis');
        }
      })
      
    }
  },
  methods: {
    toggleFullscreen() {
      const element = document.getElementById('fullscreenElement');
      if (!document.fullscreenElement) {
        // 请求全屏
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) { // Firefox
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { // IE/Edge
          element.msRequestFullscreen();
        }
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen();
        }
      }
    },
    /**
     * 给iframe的window对象绑定方法
     */
    bindWindowFuncs(win) {
      win.parentWindow = {
        websocketUrl,
        timeOptions: this.timeOptions,
        jfpgBarGraph,
        eleJfpgReport,
        // currentArea: this.currentArea,
        // getStationDetail,
        // pickDate: this.pickDate,
        getRtDataByItemIds,
        getHistoryDataCurve,
        toggleFullscreen: this.toggleFullscreen,
        // getHistoryDataSum,
        // getHistoryDataItemsSum,
        // getAlarmList,
        // getAlarmCount,
        getDataPageDetail,
        getViewDetail: getDataPageDetail, // 组态跳转
        sendRequest: this.sendRequest,
        getBigScreenInfo,
        // startVideo,
        // sendYk: this.sendYk,
        // sendYt: this.sendYt
      }
    },
    sendRequest() {
      return new Promise((resolve, reject) => {
        resolve({code: 200, data: 'xxx'})
      })
    },
    /**
     * 发送遥控
     */
    sendYk(data) {
      return setYk(data).then(() => {
        this.$notify({ title: '成功', message: '发送遥控成功', type: 'success' })
      })
    },
    sendYt(data) {
      return setYt(data).then(() => {
        this.$notify({ title: '成功', message: '发送遥调成功', type: 'success' })
      })
    },
    pickDate({ date, dateType }, callback) {
      this.$refs['datePicker'].form.date = date
      this.$refs['datePicker'].form.dateType = dateType
      if (callback) {
        this.dialogCallback = callback
        this.dialogVisible = true
      }
    },
    onChooseDate({ date, dateType }) {
      this.dialogCallback && this.dialogCallback(date, dateType)
    }
  }
}
</script>
<style lang="scss" scoped>
.zutai-editor {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // background: pink;
}
</style>
